import React from "react";
import "./ServiceComponents.css";

// Video imports
import ChatAppVid from "../assets/images/projectimg/chat-app.mp4";
import InventoryAppVid from "../assets/images/projectimg/items-inventory.mp4";
import SOSAppVid from "../assets/images/projectimg/sos.mp4";
import InvitationAppVid from "../assets/images/projectimg/sesame.mp4";

// Thumbnail imports
// import ChatThumb from "../images/projectimg/chat-thumb.jpg";
// import InventoryThumb from "../images/projectimg/inventory-thumb.jpg";
// import SOSThumb from "../images/projectimg/sos-thumb.jpg";
// import InvitationThumb from "../images/projectimg/invite-thumb.jpg";

const MobileApps = () => {
  const projects = [
    {
      id: 1,
      title: "Chat & Calling App",
      description:
        "A real-time chat & calling app built using Jetpack Compose with Express + TypeScript backend using sockets. Supports offline messages, media sharing, dark mode, and WhatsApp-like UI.",
      category: "Communication",
      video: ChatAppVid,
      //   thumbnail: ChatThumb,
    },
    {
      id: 2,
      title: "Items Inventory Management App",
      description:
        "A Flutter-based inventory management app with Firebase backend. Syncs across devices, supports sharing, Google Ads, and in-app purchases for premium plans.",
      category: "Productivity",
      video: InventoryAppVid,
      //   thumbnail: InventoryThumb,
    },
    {
      id: 3,
      title: "SOS Alert App",
      description:
        "A safety-focused SOS alert application built in Flutter for mobile users with an ElectronJS + React admin dashboard.",
      category: "Safety & Emergency",
      video: SOSAppVid,
      //   thumbnail: SOSThumb,
    },
    {
      id: 4,
      title: "Invitation Maker App",
      description:
        "A creative invitation builder with text, images, and animations. Built using React + Konva.js and deployed as a WebView inside React Native.",
      category: "Design & Events",
      video: InvitationAppVid,
      //   thumbnail: InvitationThumb,
    },
  ];

  const openVideoInNewTab = (videoUrl) => {
    window.open(videoUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <div className="service-component">
        <h2 className="service-title">Mobile Apps Projects</h2>
        <p className="service-description">
          Scalable, high-performance mobile applications built with modern
          frameworks and real-world use cases.
        </p>

        <div className="projects-grid">
          {projects.map((project) => (
            <div key={project.id} className="project-card">
              <div className="project-image">
                <video
                  className="project-video"
                  src={project.video}
                  poster={project.thumbnail}
                  muted
                  controls
                  playsInline
                />
              </div>

              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-desc">{project.description}</p>

                <div className="project-category">
                  <span className="category-badge">{project.category}</span>
                </div>

                <button
                  className="project-btn"
                  onClick={() => openVideoInNewTab(project.video)}
                >
                  View Demo Video
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <p style={{ textAlign: "center", marginTop: "20px" }}>
        🚀 Stay tuned for more mobile app projects...
      </p>
    </>
  );
};

export default MobileApps;
